import { css } from '@emotion/react';
import { CSSProperties } from 'react';

export const generateBarStyle = (properties: CSSProperties) => css({ ...properties });
